/*
 * @Author: 赵泽文
 * @Date: 2022-03-03 10:30:24
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-07-11 09:16:53
 * @Description: 调出单数据存储
 */

import type {
  ITransferOutOrderModel,
  ITransferOutOrderStore,
} from '@monorepo/types/orders/transferOutOrder/transferOutOrder.types';
import { tableUpdate } from '@monorepo/utils';
import { getToday } from '@monorepo/utils';

const initState: ITransferOutOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
    print_num: 'ALL',
  },
  total_money: '0',
  total_use_unit_qty: '0',
  auditNo: '',
  auditProductList: [],
};

const transferOutOrderStore: ITransferOutOrderModel = {
  namespace: 'transferOutOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default transferOutOrderStore;
